import script from "./TripsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TripsView.vue?vue&type=script&lang=ts&setup=true"

import "./TripsView.vue?vue&type=style&index=0&id=de832fe8&lang=scss"

const __exports__ = script;

export default __exports__